import { setCatalogByHash } from '../../../plugins/mojeid_matalog/static/mojeid_matalog/js/catalog_by_hash'

import { setCMSBarWidth } from './cms-bar-width'
import { appendVersions } from './site-common'
import { clickToClass } from './code'
import { showNavigationForMobile } from './navigation'
import { searchBar } from './search'
import { openFirstTab } from './tab'
import { collapseAddNameToItems, collapseOpenItemWhenFragment } from './collapse'
import { EmailForm } from './nia-email'
import { NiakampfTerms } from './niakampf-terms'
import { initOnlinechat } from './onlinechat'

window.addEventListener('DOMContentLoaded', () => {
    clickToClass('show-nav', showNavigationForMobile)
    searchBar()
    openFirstTab()
    collapseAddNameToItems()
    collapseOpenItemWhenFragment()

    for (const collapse of document.querySelectorAll('.release-notes')) {
        if (collapse.querySelector('*[id*="open"') && !window.location.hash) {
            collapse.querySelector('header[id^=trigger-open]').classList.remove('collapsed')
            collapse.querySelector('header[id^=trigger-open]').setAttribute('aria-expanded', true)
            collapse.querySelector('aside[id^=open]').classList.add('collapse', 'show')
        }
    }

    setTimeout(() => {
        // Selectbox id_category is driven by Vuejs, so wait until it is created.
        setCatalogByHash(document.getElementById('id_category'))
    }, 600)

    for (const form of document.querySelectorAll(`.nia-form`)) {
        new EmailForm(form)
    }

    for (const form of document.querySelectorAll('.niakampf-order')) {
        new NiakampfTerms(form)
    }

    const structure = document.querySelector('.cms-toolbar-item-cms-mode-switcher > a:not(.cms-btn-disabled)')
    if (structure) {
        structure.addEventListener('click', () => { setTimeout(setCMSBarWidth, 1000) }, true)
    }

    appendVersions(document.querySelector('.cms-toolbar-item-logo a'))
    initOnlinechat()
}, false)
